export default "__VITE_ASSET__8jvC5rmH__"